import { apiClient } from './client';
import { WhatsAppMessage } from '../types/communications';

export const listWhatsAppConversation = async (leadId: number): Promise<WhatsAppMessage[]> => {
  const { data } = await apiClient.get(`/whatsapp/leads/${leadId}/messages`);
  return data.data;
};

export interface SendWhatsAppPayload {
  leadId: number;
  templateId?: number;
  body?: string;
}

export const sendWhatsApp = async (payload: SendWhatsAppPayload): Promise<WhatsAppMessage> => {
  const { data } = await apiClient.post('/whatsapp/send', payload);
  return data.data;
};

export const bulkSendWhatsApp = async (payload: {
  leadIds: number[];
  templateId?: number;
  body?: string;
}): Promise<{ total: number; sent: number; failed: number; errors: Array<{ leadId: number; message: string }> }> => {
  const { data } = await apiClient.post('/whatsapp/bulk-send', payload);
  return data.data;
};
